import React from "react";

const TILES = [
  { estado: "AUTORIZADA", key: "nuevas", label: "Nuevas", sub: "Confirma que las recibiste", tone: "hot" },
  { estado: "RECIBIDA", key: "por_facturar", label: "Por facturar", sub: "Sube la factura" },
  { estado: "DEVUELTA", key: "devueltas", label: "Devueltas", sub: "Corrige y reenvía", tone: "bad" },
  { estado: "FACTURADA", key: "en_revision", label: "En revisión", sub: "Las revisa contabilidad" },
  { estado: "APROBADA", key: "aprobadas", label: "Aprobadas", sub: "Factura aceptada" },
];

const plural = (n, uno, varios) => (Number(n) === 1 ? uno : varios);

/** Inicio del proveedor de repuestos: su cuenta, conteos y cómo funciona. */
export default function RepuestosInicio({ me, loading, meError, onRetry, onOpenList }) {
  if (loading && !me) {
    return <div className="center"><div className="spinner" /></div>;
  }

  if (meError) {
    return (
      <>
        <div className="banner err" style={{ marginTop: 16 }}>{meError}</div>
        <button className="btn" onClick={onRetry}>Reintentar</button>
      </>
    );
  }

  const s = me?.supplier || {};
  const c = me?.counts || {};
  const nuevas = Number(c.nuevas || 0);
  const devueltas = Number(c.devueltas || 0);
  const porFacturar = Number(c.por_facturar || 0);

  return (
    <>
      <div className="acct">
        <div className="acct-head">
          <div className="acct-name">{s.name || "—"}</div>
          <span className="chip mode">Proveedor autorizado</span>
        </div>
        <div className="acct-note">
          {s.document_number ? `NIT / documento ${s.document_number}` : ""}
          {s.document_number && s.city ? " · " : ""}
          {s.city || ""}
          {me?.user?.email ? ` · Usuario: ${me.user.email}` : ""}
        </div>
      </div>

      <div style={{ marginTop: 14 }}>
        {nuevas > 0 && (
          <div className="banner warn strong">
            Tienes {nuevas} {plural(nuevas, "autorización nueva", "autorizaciones nuevas")}. Ábrela
            {nuevas > 1 ? "s" : ""}, revisa los datos y presiona «Recibí la autorización».
            <div style={{ marginTop: 10 }}>
              <button type="button" className="btn-sm" onClick={() => onOpenList("AUTORIZADA")}>
                Ver nuevas
              </button>
            </div>
          </div>
        )}
        {devueltas > 0 && (
          <div className="banner err">
            Contabilidad te devolvió {devueltas} {plural(devueltas, "factura", "facturas")}. Mira el
            motivo, corrígela{devueltas > 1 ? "s" : ""} y vuelve a enviarla{devueltas > 1 ? "s" : ""}.
            <div style={{ marginTop: 10 }}>
              <button type="button" className="btn-sm danger" onClick={() => onOpenList("DEVUELTA")}>
                Ver devueltas
              </button>
            </div>
          </div>
        )}
        {nuevas === 0 && devueltas === 0 && porFacturar > 0 && (
          <div className="banner info">
            Tienes {porFacturar} {plural(porFacturar, "autorización", "autorizaciones")} por facturar.
          </div>
        )}
      </div>

      <div className="section">Tus autorizaciones</div>
      <div className="rep-tiles">
        {TILES.map((t) => {
          const n = Number(c[t.key] || 0);
          const tone = n > 0 && t.tone ? t.tone : "";
          return (
            <button
              key={t.key}
              type="button"
              className={`rep-tile ${tone}`}
              onClick={() => onOpenList(t.estado)}
            >
              <div className="lbl">{t.label}</div>
              <div className="val">{n}</div>
              <div className="sub">{t.sub}</div>
            </button>
          );
        })}
      </div>
      <button type="button" className="btn ghost" onClick={() => onOpenList("")}>
        Ver todas las autorizaciones
      </button>

      <div className="section">¿Cómo funciona?</div>
      <div className="card">
        <ol className="rep-steps">
          <li>
            El propietario del bus te <b>autoriza</b> el repuesto o servicio. Te llega un correo y la
            autorización aparece aquí como <b>Nueva</b>.
          </li>
          <li>
            Revisa el bus, lo que se autoriza y el valor, y presiona <b>«Recibí la autorización»</b>.
          </li>
          <li>
            Cuando entregues el repuesto, <b>factura</b>: sube el <b>XML</b> de tu factura electrónica
            (y si quieres, el PDF). Si no facturas electrónicamente, sube el PDF o una foto de la
            factura y escribe sus datos.
          </li>
          <li>
            El sistema revisa la factura: que la emitas tú, que no esté repetida y que el valor
            corresponda a lo autorizado.
          </li>
          <li>
            <b>Contabilidad</b> la revisa: si está bien la aprueba; si algo no cuadra te la{" "}
            <b>devuelve con el motivo</b> para que la corrijas y la vuelvas a enviar.
          </li>
        </ol>
      </div>
    </>
  );
}
